import { getMapFeatureCenter } from "./getMapFeatureCenter";

export default getMapFeatureCenter;
